import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },

  upperDiv: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(0),
  },

  contractSelectionBox: {
    background: theme.palette.bgPrimary.main,
    borderRadius: theme.spacing(1),
  },

  questionRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
  },

  radioGroup: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(3),
    flexWrap: 'nowrap',
    width: '100%',
    alignItems: 'stretch',
  },

  linkStyle: {
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    color: theme.palette.icon.blue,
    fontWeight: 500,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'none',
    },
  },

  heading: {
    color: theme.palette.labraText.primary,
    fontSize: theme.spacing(2),
    fontWeight: 400,
    lineHeight: theme.spacing(3),
    letterSpacing: theme.spacing(0.03125),
  },

  value: {
    color: theme.palette.textField.dark,
    fontSize: theme.spacing(2),
    fontWeight: 400,
    lineHeight: theme.spacing(3),
    padding: theme.spacing(1, 0, 0, 0),
  },

  installmentSelection: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },

  iconButton: {
    cursor: 'pointer',
    display: 'inline-flex',
    color: theme.palette.icon.blue,
  },

  fileContractIcon: {
    width: theme.spacing(1.75),
    height: theme.spacing(1.75),
  },

  optionCard: {
    flex: '1 1 0',
    width: '50%',
    minWidth: '0',
    maxWidth: '50%',
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.newColors.white,
    boxShadow: 'none',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    '& .MuiFormControlLabel-label': {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
    },
    '& .MuiRadio-root': {
      padding: 0,
      marginRight: theme.spacing(1),
      marginTop: theme.spacing(0.25),
      flexShrink: 0,
    },
  },

  selectedCard: {
    backgroundColor: theme.palette.newColors.white,
  },

  cardFormLabel: {
    '&.MuiFormControlLabel-root': {
      width: '100%',
      height: '100%',
      margin: 0,
      padding: theme.spacing(1.5),
      alignItems: 'flex-start',
      display: 'flex',
      flexDirection: 'row',
    },
  },

  cardLabelContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    width: '100%',
  },

  cardTitle: {
    color: theme.palette.labraText.tertiary,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.spacing(1.75),
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: theme.spacing(2.5),
    letterSpacing: theme.spacing(0.03125),
    verticalAlign: 'middle',
    margin: 0,
  },

  cardDescription: {
    color: theme.palette.labraText.description,
    fontSize: theme.spacing(1.75),
    fontWeight: 400,
    lineHeight: theme.spacing(2.5),
    letterSpacing: '0',
    margin: 0,
  },

  cardDescriptionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },

  cardDescriptionSecondLine: {
    marginTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(1),
  },
}))
